import { ChangeDetectionStrategy, Component } from '@angular/core';
import { fadeInOut } from '../../../utils/animations';
import { ProductTourService } from '../../../services/product-tour.service';
import { AsyncPipe } from '@angular/common';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-product-tour-background',
  templateUrl: './product-tour-background.component.html',
  styleUrl: './product-tour-background.component.scss',
  animations: [fadeInOut],
  imports: [AsyncPipe],
})
export class ProductTourBackgroundComponent {
  constructor(public productTourService: ProductTourService) {}
}
